module.exports = __webpack_public_path__ + "img/海尔.9fd467ab.png";